import type { RootState } from '@core/Store'

export const selectSearchCriteria = (state: RootState) => state.structuredSearch.searchCriteria
